import React from 'react'
import { useSelector } from "react-redux";
import { Navigate } from 'react-router-dom';
import useFetchData from "../../hooks/use-fetch-datas"
import Loader from './loader';

const PrivateRoute = ({ children }) => {
  const { loading, user } = useSelector(state => state.auth)
  const {
    projects,
    types,
    managers,
    loadingdatas,
  } = useFetchData();

  if (loading || loadingdatas) return <Loader />;

  return user ? children : <Navigate to='/login' replace />
}

export default PrivateRoute